import * as React from 'react';
import { Table, Button } from 'reactstrap';
import { DownArrow, UpArrow } from '../../components/Icons';

const partnersStyles = require('./partners.css');
const iconStyles = require('../../components/icons.css');

export const PartnersTable = ({
  state,
  getTableProps,
  headerGroups,
  getTableBodyProps,
  rows,
  prepareRow,
  pageOptions,
  page,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  handleRowClick,
}) => {
  const pageIndex = state.pageIndex;

  return (
    <div className={partnersStyles.fullHeight}>
      <div className={partnersStyles.fullHeightTableContainer}>
        <div className={partnersStyles.fitContentTableContainer}>
          <Table
            {...getTableProps()}
            striped
            className={partnersStyles.partnersTable}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render('Header')}
                      <div>
                        {column.canFilter ? column.render('Filter') : null}
                      </div>
                      <Button
                        className={partnersStyles.sortButton}
                        size="sm"
                        color="link"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.isSorted ? 'sorted ' : 'sort'}
                        <span>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <DownArrow
                                fill="#007bff"
                                class={iconStyles.sortButton}
                              />
                            ) : (
                              <UpArrow
                                fill="#007bff"
                                class={iconStyles.sortButton}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </span>
                      </Button>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className={partnersStyles.selectableRow}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td
                          {...cell.getCellProps({
                            onClick: (e) =>
                              handleRowClick && handleRowClick(row, cell, e),
                          })}
                        >
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className={partnersStyles.pagination}>
          <div>
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Previous Page
            </Button>
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
              Next Page
            </Button>
          </div>
          <div>
            Page{' '}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
        </div>
        Total Rows: {rows.length}
      </div>
    </div>
  );
};
